module.exports = __webpack_public_path__ + "static/media/basic.css.e2be182d.bak";